import React from 'react';
import { useTranslation } from 'react-i18next';
import PreviewTitle from '../../previewTitle/previewTitle';

const DeductionFromPayoutsPreview = () => {
	const { t } = useTranslation();

	return (
		<div data-testid="payout-preview">
			<PreviewTitle size="two">{t('payment_method.payout.label')}</PreviewTitle>
		</div>
	);
};

export default DeductionFromPayoutsPreview;
